import React from 'react';

import { PageSection } from 'Components/Layout';
import RunExportSection from './RunExportSection';
import ReIssueSection from './ReIssueSection';
import './ProjectAgsExportSection.scss';

const ProjectAgsExportSection: React.FC = () => {
  return (
    <PageSection heading="AGS Export" id="AgsProjectExportPage">
      <RunExportSection />
      <ReIssueSection />
    </PageSection>
  );
};

export default ProjectAgsExportSection;
